const videos = document.querySelectorAll('.js-apm-background-video');
const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

/**
 *
 *
 *
 */
const init = function() {
  
  if (!mediaQuery || mediaQuery.matches) {

    // stop video from playing
    videos.forEach( (video) => {
      video.pause();
    });

  }

};


const api = {
	init: init
};

export default api;